<template>
  <v-app>
    <v-content>
      <ToolBar :profile="profile" :loggedIn="loggedIn" />
      <LandingPage />
    </v-content>
  </v-app>
</template>

<script>
import LandingPage from '@/components/LandingPage';
import ToolBar from '@/components/ToolBar';
import { mapGetters } from 'vuex';

export default {
  components: {
    LandingPage,
    ToolBar
  },
  computed: {
    ...mapGetters({
      loggedIn: 'User/loggedIn',
      profile: 'User/profile'
    })
  },
  data() {
    return {
      options: {
        query: '',
        startTime: '',
        endTime: '',
        sort: 'timestamp+desc',
        eventCategory: [],
        eventRegion: [],
        locationCode: [],
        eventImportance: [],
        initial: true
      },
      loader: true
    };
  },
  watch: {
    loggedIn(newValue) {
      if (newValue == false) {
        this.$router.replace('login');
      }
    }
  },
  mounted() {
    //write a boolean if the user is new
    // then use the default option dispatch
    this.$store.dispatch('search', this.options);
    // setTimeout(() => {
    //   this.loader = false;
    // }, 5500);
  }
};
</script>

<style scoped>
.dialog {
  z-index: 9999;
}
</style>
